import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
export const StyledPaper = styled(Paper)`
  margin: 0;
  padding: ${({ theme }) => theme.spacing(1, 4)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
